import { physiosPageContent } from "../../data/physiosPageContent";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import "../../styles/physio.css";
// "Revimo doesn't replace you" positioning statement
export default function PhysioPositioning() {
  const currentLang = useCurrentLang();
  const t = physiosPageContent[currentLang];
  return (
    <section id="positioning" className="physio-section physio-positioning">
      <div className="glass-card positioning-card">
        <div className="positioning-text">
          <span className="physio-eyebrow">{t.physiosPos.s}</span>
          <h2>{t.physiosPos.t1}</h2>
          <div className="physio-divider" />
          <p>
            {t.physiosPos.desc1}
          </p>
          <p>
           {t.physiosPos.desc2}
          </p>
          <p className="positioning-highlight">
           {t.physiosPos.imp}
          </p>
        </div>
        <div className="positioning-img">
          <img
            src="https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&q=80&fit=crop"
            alt="Physiotherapist in focused consultation with patient"
            width="800"
            height="300"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}
